Error.stackTraceLimit = 5;
const DEFAULT_NO_LOGGER_MESSAGE =
  "No Logger Defined! use startLogger() or MWA Logger().";

// only one customLogger per app
// private var
let customLogger = (args) => {
  console.log(DEFAULT_NO_LOGGER_MESSAGE);
  console.log(args?.errorOrString);
};

/**
 * @param {function} customLogFunction A logging utility that filters the error object for use in Sentry
 */
export const startLogger = (customLogFunction) => {
  customLogger = customLogFunction;
};

/**
 * "logger" will take a format similar to Node and MWA loggers, then call a custom logger with object parameters.
 * Important: before using this, you must call startLogger() with a custom logger function.
 */
export const logger = {
  fatal: (errorOrString, props, scopeFn) =>
    customLogger({
      errorOrString,
      props,
      scopeFn,
      type: "fatal"
    }),
  error: (errorOrString, props, scopeFn) =>
    customLogger({
      errorOrString,
      props,
      scopeFn,
      type: "error"
    }),
  warn: (errorOrString, props, scopeFn) =>
    customLogger({
      errorOrString,
      props,
      scopeFn,
      type: "warn"
    }),
  info: (errorOrString, props, scopeFn) =>
    customLogger({
      errorOrString,
      props,
      scopeFn,
      type: "info"
    }),
  debug: (error) => console.log("DEBUG: ", error)
};
